import { createContext, useState } from "react";

export const updateWorkSpace = createContext();

export const WorkSpaceProvider = ({ children }) => {
    const currentWorkSpace = localStorage.getItem("work-space") || "hrp";
    const [workSpace, setWorkSpace] = useState(currentWorkSpace);
    return <updateWorkSpace.Provider value={[workSpace, setWorkSpace]}>{children}</updateWorkSpace.Provider>;
};
